<template>
<div class="chapter">
<div class="inner_page">
<h2 class="bk-title"><a id="title"></a>Charlie Muffin U.S.A.</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?82ef8764